import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatSnackBar } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { TitulosReprogramación, InformacionCobro, Cobradores } from 'app/entities/cobranza';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { myFilter } from 'utilities/util';
import { ActividadNotasComponent } from '../actividad-notas/actividad-notas.component';
import { DataTableDirective } from 'angular-datatables';
import { ReportePagoComponent } from '../reporte-pago/reporte-pago.component';
import { AbonoFacturaComponent } from '../abono-factura/abono-factura.component';

@Component({
  selector: 'app-ver-cobro',
  templateUrl: './ver-cobro.component.html',
  styleUrls: ['./ver-cobro.component.scss']
})
export class VerCobroComponent implements OnInit {

  /**
   * DATA_TABLES  
   */
  public tableOpt = [];
  public dtOptions;
  @ViewChild(DataTableDirective, {static: true})
  tabla: DataTableDirective

  public info_grupoCobro: TitulosReprogramación;
  newForm: FormGroup;
  public myFilter = myFilter;
  public disable: boolean = true;
  public cobradores: Array<Cobradores> = [];
  cobros_reprogramar: Array<any> = [];
  facturas_llamada: Array<any> = [];
  public isNull_Facturas: boolean = false;

  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _cartera: CarteraService,
    public _dialog: MatDialogRef<VerCobroComponent>,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  )
  {
    this._cartera.verUltimoCobro(_data.data_base, _data.grunit, _data.grugru).subscribe((data: InformacionCobro) => {
      this.newForm = this.createNewForm(data);
      this.info_grupoCobro = {
        Grupo: {
          id_grupo: _data.id_grupo,
          codigo_grupo: _data.grunit,
          radicado_grupo: _data.grugru,
          ciclo_grupo: _data.ciclo,
          estado_grupo: _data.estado,
          nombre_grupo: _data.nombre,
          nvo_saldo: _data.nvo_saldo,
        },
        Cobro: {
          FechaCobro: data.FechaCobro,
          estado_cobro: data.estado_cobro,
          UsuarioCreador: data.UsuarioCreador,
          FechaRegistro: data.FechaRegistro,
          Reprogramador: data.Reprogramador,
          ReprogramacionFecha: data.ReprogramacionFecha,
          TipoCobro: data.TipoCobro,
          TipoAbono: data.TipoAbono,
          Mes_FacturaAbono: data.Mes_FacturaAbono,
          MontoAbono_Cobro: data.MontoAbono_Cobro,
          llamar_confirmar: data.llamar_confirmar,
        }
      }
      this.tableOpt = data.Facturas;
    });
  }

  ngOnInit() {
    this._cartera.VerCobradores().subscribe((data: Array<any>) => {
      data.forEach((element, i) => {
        this.cobradores[i] = {
          codigo: element.documento_usuario,
          nombre: element.nombre_completo
        }
      });
    });

    this.dtOptions = {
      order: [3, 'desc'],
      columns: [
        {},
        {
            title: 'N° Fact.',
            data: 'NoFactura'
        },
        {
            title: 'Nombre',
            data: 'Nombre_Fac'
        },
        {
            title: 'Fecha Fact.',
            data: 'FechaFac'
        },
        {
            title: 'N° Ben.',
            data: 'NoBen'
        },
        {
            title: 'Valor Unit.',
            data: 'Val_Unit'
        },
        {
            title: 'Valor Total',
            data: 'Val_Tot'
        },
        {
            title: 'Saldo Ant.',
            data: 'Saldo_Ant'
        },
        {
          title: 'Nvo Saldo',
          render: (data, row, type, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {}
      ],
      dom: 'Rt',
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        $('.checkbox', row).unbind('click');
        $('.checkbox', row).bind('click', (e) => {
            self.someClickHandler(data);
        });
        return row;
      }
    }
  }

  createNewForm(cobro: InformacionCobro): FormGroup
  {
    return new FormGroup({
      informacionGrupo:  this._formBuilder.group({
        database: new FormControl(this._data.data_base),
        ID_grupo: new FormControl(this._data.id_grupo),
        empresa: new FormControl(this._data.data_base === 'medisoft' ? '1' : '2'),
        radicado: new FormControl(this._data.grugru),
        ciclo: new FormControl(this._data.ciclo)
      }),
      id_cobro: new FormControl(cobro.ID_Cobro),
      tipo_factura: this._formBuilder.group({
        fact_fisica: new FormControl(cobro.Grupo.factura_fisica === '0'? false : true),
        fact_elect: new FormControl(cobro.Grupo.factura_elec === '0'? false : true)
      }),
      telefono: new FormControl(cobro.Grupo.telefono_grupo,[
        Validators.pattern('^[0-9-]{0,18}$')
      ]),
      celular: new FormControl(cobro.Grupo.celular_grupo,[
        Validators.pattern('^[0-9-]{0,18}$')
      ]),
      jornada: new FormControl(cobro.JornadaCobro.toString()),
      hora: new FormControl(cobro.HoraCobro),
      llamada: this._formBuilder.group({
        llamada: new FormControl(false),
        responsable: new FormControl(),
        hora: new FormControl(),
      }),
      direcciones: this._formBuilder.group({
        sistema: new FormControl(cobro.Grupo.direccion),
        factura: new FormControl(cobro.Grupo.direccion_fact),
        alternativa: new FormControl(cobro.DirAlternativa),
        cobro: new FormControl(cobro.Grupo.direccion_cobro)
      }),
      observaciones: this._formBuilder.group({
        cobro: new FormControl(cobro.ObservacionesCobro),
        cartera: new FormControl(cobro.Grupo.observacion_cartera),
        contrato: new FormControl(cobro.Grupo.observacion_contrato),
        llamada: new FormControl()
      }),
      info_cobrador: this._formBuilder.group({
        cobrador: new FormControl(cobro.ID_Cobrador),
        actividad: new FormControl({value: cobro.ActividadCobro, disabled: true}),
        notas: new FormControl(cobro.NotasOtros)
      }),
      cobro: this._formBuilder.group({
        tipo_cobro: new FormControl({value: cobro.TipoCobro, disabled: true}),
        tipo_abono: new FormControl({value: cobro.TipoAbono, disabled: true}),
        mes_abono: new FormControl({value: cobro.Mes_FacturaAbono, disabled: true}),
        valor_abono: new FormControl({value: cobro.MontoAbono_Cobro, disabled: true})
      }),
      reprogramacion: this._formBuilder.group({
        tipo_reprog: new FormControl(),
        fecha: new FormControl(),
        usuario: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
      }),
      cobros_reprogramar: new FormControl(),
      facturas_llamada: new FormControl(),
      llamar_confirmar: new FormControl(cobro.llamar_confirmar ? true : false),
      fecha_llamConfirm: new FormControl(cobro.llamar_confirmar),
      usuario: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
    });
  }

  public capturarHoraLlamada(): void{
    this.newForm.get('llamada.hora').setValue(moment().format('HH:mm:ss'));
  }

  public copiarDireccion(direccion: string, origen: string): void{
    this.newForm.get(`direcciones.${origen}`).setValue(direccion);
  }

  public modalNotas(): void{
    let modal;
    modal = this.dialog.open(ActividadNotasComponent, {
      width: '25%',
      data: {
          modal: this.newForm.get('info_cobrador.notas').value,
          disabled: this.disable
      }
    });
    modal.afterClosed().subscribe((data: any) => {
      if(data) this.newForm.get('info_cobrador.notas').setValue(data);
    });
  }

  someClickHandler(info: any): void {
    if(!this.disable){
      let indice_factura = this.tableOpt.findIndex(ind_fact => ind_fact.NoFactura === info.NoFactura);
      let cobro_id = this.tableOpt[indice_factura]['ID_Cobro'];

      // Cobros Seleccionados a Reprogramar
      if(!this.cobros_reprogramar.includes(cobro_id)){
        this.cobros_reprogramar.push(cobro_id);
      }else{
        this.cobros_reprogramar.forEach((cobro, index) => {
          if(cobro === cobro_id) this.cobros_reprogramar.splice(index, 1);
        });
      }

      this.newForm.get('cobros_reprogramar').setValue(this.cobros_reprogramar);

      // facturas incluidos en la llamada
      if(!this.facturas_llamada.includes(info.NoFactura)){
        this.facturas_llamada.push(info.NoFactura);
      }else{
        this.facturas_llamada.forEach((factura, index) => {
          if(factura === info.NoFactura) this.facturas_llamada.splice(index, 1);
        });
      }

      this.newForm.get('facturas_llamada').setValue(this.facturas_llamada);

    }else{
      return;
    }
  }

  public modalReportePago(id_cobro: string): void{
    this.dialog.open(ReportePagoComponent, {
      width: '25%',
      data: {
        id_cobro: id_cobro
      }
    });
  }

  public modalAbonarFactura(factura: string, monto: string){
    let modal;
    modal = this.dialog.open(AbonoFacturaComponent, {
        width: '25%',
        data: {
            NoFactura: factura,
            abono: monto
        }
    });
  }

  public editarCobro(): void{
    // Formatear la fecha que toma del input tipo Date Reprogramación Fecha
    if(this.newForm.get('reprogramacion.fecha').value){
      this.newForm.get('reprogramacion.fecha').setValue(moment(this.newForm.get('reprogramacion.fecha').value).format('YYYY-MM-DD'));
    }

    // Formatear la fecha que toma del input tipo Date Fecha Llamar a confirmar
    if(this.newForm.get('fecha_llamConfirm').value){
      this.newForm.get('fecha_llamConfirm').setValue(moment(this.newForm.get('fecha_llamConfirm').value).format('YYYY-MM-DD'));
    }

    //Validaciones
    if(!this.validarEdicion(this.newForm.value)){
      return;
    }

    //Servicio para actualizar el cobro
    this._cartera.ActualizarCobro(this.newForm.value).subscribe((data: any) => {
      if(data['affectedRows'] > 0){
        this._snackBar.open('Cobro Actualizado Correctamente', 'Aceptar', {
          duration: 2000
        });
        this.disable = true;
      }else{
        this._snackBar.open('Error al actualizar el cobro', '', {
          duration: 2000,
          panelClass: 'warn-600'
        });
      }
    });
  }

  validarEdicion(form: any): boolean{
    const formValue: any = this.newForm.value;

    if(!this.tableOpt[0].ID_Factura || this.tableOpt[0].ID_Factura){
      //Si en fecha reprogramación existe un valor y en tipo reprogramacion no, retorna false 
      if(formValue['reprogramacion'].fecha && !formValue['reprogramacion'].tipo_reprog){
        this.newForm.get('reprogramacion.tipo_reprog').setErrors({ invalid: true});
        this._snackBar.open('Tipo Reprogramación Faltante', '', {
          duration: 2000,
          panelClass: 'yellow'
        });
        return false;
        //Si en fecha reprogramacion no existe un valor y en tipo reprogramacion si, retorna false
      }else if(!formValue['reprogramacion'].fecha && formValue['reprogramacion'].tipo_reprog){
        this.newForm.get('reprogramacion.fecha').setErrors({ invalid: true});
        this._snackBar.open('Fecha Reprogramación Faltante', '', {
          duration: 2000,
          panelClass: 'yellow'
        });
        return false;
        //Si en el cobro existen facturas, fecha reprogramación y tipo reprogramación pero no han seleccionado facturas, retorna false
      }else if(this.tableOpt[0].ID_Factura && formValue['reprogramacion'].fecha && formValue['reprogramacion'].tipo_reprog && !this.cobros_reprogramar.length){
        this.isNull_Facturas = true;
        this._snackBar.open('Seleccione una factura', 'Aceptar', {
          duration: 2000,
          panelClass: 'yellow'
        });
        return false;
        //Si en el cobro existen facturas, llamada activa pero no tiene facturas seleccionada, retorna false
      }else if(this.tableOpt[0].ID_Factura && formValue['llamada'].llamada && !this.cobros_reprogramar.length){
        this.isNull_Facturas = true;
        this._snackBar.open('Seleccione una factura', 'Aceptar', {
          duration: 2000,
          panelClass: 'yellow'
        });
        return false;
      }
    }
    this.isNull_Facturas = false;
    return true;
  }
}
